import isMetricReportConfig from './isMetricReportConfig';

const reportGeneratorTypeCheckers = {
  isMetricReportConfig,
};

export default reportGeneratorTypeCheckers;
